import React, { useState, useEffect } from "react";
import "./Banners.css";
import axiosConfig from "../../Service/axiosConfig";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";

const Banners = ({ data }) => {
  var settings = {
    centerMode: true,
    centerPadding: "60px",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 766,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
    ],
  };

  return (
    <>
      <div className="banners-container">
        <div className="container">
          <Slider {...settings}>
            {data?.map((sliderItem) => {
              return (
                <div className="banner-item" key={sliderItem.id}>
                  <NavLink
                    to={
                      sliderItem.sub_slug === null
                        ? "#"
                        : `${sliderItem.sub_slug}`
                    }
                  >
                    <div className="banner-img">
                      <img
                        src={
                          sliderItem.image__image
                            ? sliderItem.image__image
                            : sliderItem.image
                        }
                      />
                    </div>
                  </NavLink>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};
export { Banners };
